<article class="hs-homepage" aria-live="polite">
  <div class="hs-homepage-page">
    <aside class="hs-homepage-sidebar" aria-label="Filter health and safety events">
      <div class="filter-container">
        <div class="filter-container__header">
          <h2 class="filter-title">Filters</h2>
          <div class="filter-container__actions">
            <button
              mat-button
              class="filterButtons"
              (click)="clearFilters()"
              [disabled]="loadingFilterOptions || filterError"
            >
              Clear
            </button>
          </div>
        </div>

        <div class="filter-fields">
          <div *ngIf="filterError" class="filter-error">
            There was a problem loading the filter options. Try again later.
          </div>

          <mat-form-field appearance="outline" class="date-filter">
            <mat-label>Date From</mat-label>
            <div class="date-filter__input-wrapper">
              <input
                matInput
                [matDatepicker]="dateFromPicker"
                [value]="selectedDateFrom"
                (dateChange)="onDateFromChange($event)"
                readonly
                [disabled]="loadingFilterOptions || filterError"
              />
              <button
                *ngIf="selectedDateFrom !== null"
                mat-icon-button
                aria-label="Clear date"
                class="date-filter__clear-button"
                (click)="clearDateFrom()"
                [disabled]="loadingFilterOptions || filterError"
              >
                <mat-icon>clear</mat-icon>
              </button>
            </div>
            <mat-datepicker-toggle
              *ngIf="selectedDateFrom === null"
              matSuffix
              [for]="dateFromPicker"
              [disabled]="loadingFilterOptions || filterError"
            >
            </mat-datepicker-toggle>
            <mat-datepicker #dateFromPicker></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" class="subcontractor-filter">
            <mat-label>Subcontractor</mat-label>
            <mat-select
              [(ngModel)]="selectedSubcontractorId"
              (selectionChange)="onSubcontractorChange()"
              [disabled]="loadingFilterOptions || filterError"
            >
              <mat-option [value]="null">All Subcontractors</mat-option>
              <mat-option *ngFor="let subcontractor of filterOptions.subcontractors" [value]="subcontractor.id">
                {{ subcontractor.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="assessor-filter">
            <mat-label>Assessor</mat-label>
            <mat-select
              [(ngModel)]="selectedAssessorId"
              (selectionChange)="onAssessorChange()"
              [disabled]="loadingFilterOptions || filterError"
            >
              <mat-option [value]="null">All Assessors</mat-option>
              <mat-option *ngFor="let assessor of filterOptions.assessors" [value]="assessor.id">
                {{ assessor.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </aside>

    <div class="hs-homepage-main">
      <div class="admin-layout-header-container hs-homepage-header">
        <div class="hs-homepage-header__text">
          <h2 class="admin-layout-header">Health &amp; Safety</h2>
          <p class="admin-layout-description hs-homepage-subtitle">
            <mat-icon class="hs-homepage-subtitle__icon" aria-hidden="true">health_and_safety</mat-icon>
            <span class="hs-homepage-subtitle__text">Health &amp; Safety Events</span>
          </p>
        </div>

        <nav
          *ngIf="availableTabs.length"
          class="hs-homepage-header__tabs"
          role="tablist"
          aria-label="Health and safety event categories"
        >
          <button
            type="button"
            class="hs-homepage-header__tab"
            *ngFor="let tab of availableTabs"
            [class.hs-homepage-header__tab--active]="activeTab === tab"
            (click)="selectTab(tab)"
            role="tab"
            [attr.aria-selected]="activeTab === tab"
          >
            {{ tab }}
          </button>
        </nav>
      </div>

      <mat-divider class="admin-divider-spacing"></mat-divider>

      <section class="hs-homepage-content" aria-label="Health and safety events">
        <hs-events (tabChanged)="onTabChanged($event)" (filterDateChanged)="onFilterDateChanged($event)"></hs-events>
      </section>
    </div>
  </div>
</article>
